<template>

<app-content :loading="is.loading && !is.initialised">

	<app-content-head title="Transfers" subtitle="View and initiate badge transfers between attendees." :readonly="$authorised('con/badges/access', 'read')">

		<app-content-head-actions-item text="Transfer" icon="transfer" v-on:click="onCreateClick" tooltip="Initiate transfer" />

	</app-content-head>

	<app-content-filters :changed="isFilterDirty" v-on:reset="onResetFilter">

		<app-content-filters-search v-model="filter.search" />
		
		<app-content-filters-select v-model="filter.type" text="Any type" :alwaysValue="true" title="Type" tooltip="Filter by type" :options="$util.options($constants.badge.transfer.typeSelect)" />

		<app-content-filters-date v-model="filter.from" tooltip="Filter from date" text="From" :max="filter.to" />

		<app-content-filters-date v-model="filter.to" tooltip="Filter to date" text="To" :min="filter.from" />

	</app-content-filters>

	<app-content-body :loading="is.loading && is.initialised" :is-empty="!collection.length" placeholder="Sorry, no transfers found.">

		<app-table>

			<app-table-head :layout="layout">

				<app-table-column />

				<app-table-column text="From" />

				<app-table-column text="To" />

				<app-table-column text="Initiated by" />

				<app-table-column text="Transferred on" />

			</app-table-head>

			<app-table-body>

				<app-table-row :noClick="true" :layout="layout" v-for="item in collection" :key="item.id">

					<app-table-cell-label :text="$constants.badge.transfer.statusName[item.status]" :type="$constants.badge.transfer.statusTheme[item.status]" :subtext="item.reference" />
					
					<app-table-cell-item type="convention/badge" :item="item.from.badge" />
					
					<app-table-cell-item type="convention/badge" :item="item.to.badge" />
					
					<app-table-cell-text :text="$constants.badge.transfer.typeName[item.type]" :can-empty="true" />
					
					<app-table-cell-text :text="item.date | localDate('MM/DD/YYYY h:mma')" />

				</app-table-row>

			</app-table-body>

			<app-table-foot :pagination="pagination" :total="total" />

		</app-table>

	</app-content-body>

</app-content>

</template>

<script>

import mixCollection from '@/mixin/collection'

export default {

	mixins: [mixCollection],

	data: function() {

		return {
			filter: {
				from: 0,
				to: 0,
				type: 0
			},
			layout: '120px 1fr 1fr 160px 160px',
			endpoint: 'convention/badges/transfers',
			live: 'convention/badges/transfers',
			edit: 'Convention.Badges.Transfers.Edit'
		}

	}

}

</script>

<style scoped>

</style>